import { APP_ROUTES } from '@/const/appRoutes'

/** Copy for /permission-denied (subscription, platform, COMMON role pending). */
export const PERMISSION_DENIED_MESSAGES = {
  roleChanged: {
    title: 'Your role has been updated!',
    primaryAction: 'Login'
  },
  platformDenied: {
    title: 'No platform access',
    message:
      "You don't have access to this platform. Please upgrade your tuition plan.",
    primaryAction: 'Upgrade Plan',
    actionPath: APP_ROUTES.TUITION
  },
  subscriptionDenied: {
    title: 'Tuition Required',
    fallbackMessage: 'Tuition required to access this resource.',
    fallbackAction: 'Choose Plan'
  },
  rolePending: {
    title: 'Permission Denied',
    message:
      'Your access request is being processed. Permissions are typically updated within 24 hours. You can periodically refresh this page to check your current status.'
  },
  logout: {
    primaryAction: 'Return to Login'
  }
} as const
